import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


export interface ScaleAndLocationParams {
	handler: AnyHandler;

}


@Injectable({
	providedIn: 'root'
})
export class ScaleAndLocationDialogService {
	public request$: Subject<ScaleAndLocationParams> = new Subject();
	constructor() { }


	Show(handler: AnyHandler) {
		this.request$.next({
			handler: (handler),
		});
	}
}
